import { subscriptionReferenceMsg, subscriptionServiceReferencesMsg, t } from '../../../../common/i18n/index.js';
import { OpenFormGridCol, OpenFormGridRow } from '../../OpenFormComponents/OpenFormGrid.js';
import { OpenFormItem } from '../../OpenFormComponents/OpenFormItem.js';
import { type OpenFormSummary } from '../../OpenFormHooks/useOpenFormSummary.js';

export const OpenFormSummarySubscriptionReferences = ({
  summary: { subscriptionReferencesEntries },
}: {
  summary: OpenFormSummary;
}) =>
  subscriptionReferencesEntries.every(([_, sub]) => !sub) ? null : (
    <OpenFormGridRow>
      <OpenFormGridCol colWidth={9}>
        <h4>{t.AQA9(subscriptionServiceReferencesMsg)}</h4>
        <OpenFormGridRow>
          {subscriptionReferencesEntries.map(([key, sub], i) => (
            <OpenFormGridCol key={key} colWidth={6}>
              {!sub ? null : <OpenFormItem title={`${t.LVRN(subscriptionReferenceMsg)} ${i + 1}`}>{sub}</OpenFormItem>}
            </OpenFormGridCol>
          ))}
        </OpenFormGridRow>
        <hr />
      </OpenFormGridCol>
    </OpenFormGridRow>
  );
